/**
 * Which target languages have a Script mode ladder, without loading one (job #300).
 *
 * The player and the bottom nav only ask "is Script practice offered here?" before the first
 * sound, and answering it from scriptSystem.ts and characterScript.ts put every ladder (Arabic,
 * Greek, Chinese, Korean, Japanese) into every learner's boot. Those two files key their maps by
 * these lists, so TypeScript refuses a ladder added there without its code here, and the reverse.
 */
export const SCRIPT_SYSTEM_LANGS = ['ara', 'ell'] as const
export const CHARACTER_SCRIPT_LANGS = ['zho', 'cmn', 'kor', 'jpn'] as const

export type ScriptSystemLang = (typeof SCRIPT_SYSTEM_LANGS)[number]
export type CharacterScriptLang = (typeof CHARACTER_SCRIPT_LANGS)[number]

const code = (lang: string | null | undefined): string => (lang ? lang.toLowerCase().slice(0, 3) : '')

/** True when scriptSystemFor(lang) answers a system. */
export function hasScriptSystem(lang: string | null | undefined): boolean {
  return (SCRIPT_SYSTEM_LANGS as readonly string[]).includes(code(lang))
}

/** True when characterScriptFor(lang) answers a script. */
export function hasCharacterScript(lang: string | null | undefined): boolean {
  return (CHARACTER_SCRIPT_LANGS as readonly string[]).includes(code(lang))
}
